// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21Etg","buttons":"styles_buttons__1P5Gc"};